import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';
import { Role } from "@/types/user";
import { useQuery } from "@tanstack/react-query";
import { get } from "@truefit/http-utils";


export const useListSessionsQuery = ({ refetchInterval }: { refetchInterval: number }) => {
    const { sessionState } = useAuth();
    const isReady = isSignedIn(sessionState);

    return useQuery<Role[]>({
        queryKey: ['sessions'],
        queryFn: async (): Promise<Role[]> => {
            const { data } = await get('/v1.0/internals/mgmt/sessions/list');
            return data;
        },
        refetchInterval,
        enabled: isReady
    });
}